import { Col, Container, Row } from 'react-bootstrap'
import { YourBookHeroContainer } from './style'
import { useTranslation } from 'react-i18next'

function YourBookHero() {
  const { t } = useTranslation()

  return (
    <YourBookHeroContainer>
      <Container className="h-100">
        <Row className="h-100">
          <Col lg={5} md={8} xs={8}>
            <div className="home-header-content">
              <h1>{t('your_book_title')}</h1>
            </div>
          </Col>
        </Row>
      </Container>
    </YourBookHeroContainer>
  )
}

export default YourBookHero
